export const custom = {
  /**
  * Idiomas disponibles ['es','en','pt','cat']
  */
  availableLangs: ['es'],

  /**
   * Idioma por defecto: ['es']
   */
  defaultLang: 'es',

  /**
   * Versión de la API: v2|v3
   */
  apiVersion: 'v3',

  /**
   * API key de conexión a la api definida en cada entorno
   * (debe ser el mismo en todos los servicios)
   */
  apiKey: 'fd0dd4eb-0702-41b6-bae6-52bed0b68667',

  /**
   * Extensión en producción de URL de la app
   * (es, com, org...)
   */
   appUrlTld: 'com',

  /**
   * URL de la app
   *
   * subdominio.dominio
   */
  appUrlDomain: 'vivofacilplus',

  /**
  * Nombre de la app
  */
  appName: 'Vivofácil Plus',

  /**
   * Nombre de marca interno (Alares, Vivofácil...)
   */
   brandName: 'Vivofácil',

  /**
   * Mail transport (alares, vivofacil...)
   */
   mailTransport: 'vivofacil',

  /**
  * Código de analytics 'G-XXXXXXXXXXX'
  * (Activado en pro, desactivado en pre y local)
  */
  analyticsId: 'G-2944DDNBYN',

  /** true o false. Define si es necesario hacer login para acceder a los contenidos */
  protected: true,

  /** Registro habilitado o deshabilitado */
  registration: false,

  /** true o false. Define si los formularios son para conciliación o no */
  conciliation: false,

  /** numero de telefono o false. Si es false no se muestra el icono de whatsapp en las páginas */
  whatsapp: false,

  /** true o false. Define si se muestra el botón para volver al inicio */
  homeButton: false,

  /** true o false. Define si se muestra el botón de contacto en cabecera */
  headerContactButton: true, 

  /** true o false. Define si se muestra el banner de contacto en el header público y en la home */
  contactBanner: true,

  /**Cadena de string de captcha o false. Si es false, no se muestra el logo del recaptcha*/
  recaptcha: false,

  /**true o false. Define si se permite el uso de contraseñas no seguras*/
  allowInsecurePasswords: true,

  /** URL del enlace */
  externalTopLinkUrl: false,

  /** Se añade la cadena `/xxxxx` a la url del enlace adicional, donde xxxxx es el identificador del usuario en base64 */
  externalTopLinkConcatIdentifier: false,
  
  /** testamentis */
  testamentisHereditary: 'https://formularios.alares.local/form/create/1edaeaf3-6bc3-651c-ae2c-1b9a90d4d278/embed',
  testamentisLiving: 'https://formularios.alares.local/form/create/1ed08dea-bf79-6442-8808-436f6414e40d/embed'
};
